import { render, staticRenderFns } from "./SolicitudStockPantalla.vue?vue&type=template&id=ba169eb8&"
import script from "./SolicitudStockPantalla.vue?vue&type=script&lang=ts&"
export * from "./SolicitudStockPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports